import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import SearchIcon from '../Icons/SearchIcon';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Cerca',
  },
});

const SearchWidget = ({ onToggle, isOpen }) => {
  const intl = useIntl();
  const history = useHistory();

  const handleClick = () => {
    if (onToggle) {
      onToggle();
    } else {
      history.push('/search');
    }
  };

  return (
    <button
      type="button"
      className="search-icon-button"
      onClick={handleClick}
      title={intl.formatMessage(messages.search)}
      aria-label={intl.formatMessage(messages.search)}
      aria-expanded={isOpen}
    >
      <SearchIcon size={20} />
    </button>
  );
};

SearchWidget.propTypes = {
  onToggle: PropTypes.func,
  isOpen: PropTypes.bool,
};

SearchWidget.defaultProps = {
  onToggle: null,
  isOpen: false,
};

export default SearchWidget;
